import { Pipe, PipeTransform } from '@angular/core';
import { fileURLToPath } from 'url';
import { Job } from '../models/job';

@Pipe({
  name: 'jobList'
})
export class JobListPipe implements PipeTransform {

  transform(jobs: Job[], field: string, filterText: string) {
    if (!jobs) {
      return [];
    }

    if (!field || !filterText) {
      return jobs;
    }

    return jobs.filter(job => {
      if (job[field]) {
        return job[field].toLowerCase().includes(filterText.toLowerCase()) || job.name.toLowerCase().includes(filterText.toLowerCase());
      }
    }
    );

  }
}
